<template>
  <div class="content" v-loading="state.isLoading">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card id="payment">
            <template slot="header">
              <div class="row">
                <div class="col">
                  <h4 class="card-title">Bank Accounts</h4>
                </div>
                <div class="col">
                  <form class="form-inline justify-content-end">
                    <button class="btn" @click.prevent="onNewBankAccount()">Add Bank Account</button>
                  </form>
                </div>
              </div>
            </template>
            <el-table
              class="itf-table bankaccounts"
              :cell-class-name="cellClass"
              :data="tableData"
              style="width: 100%"
              :stripe="false"
              empty-text="No Data"
              >
              <el-table-column label="" width="80">
                <template slot-scope="scope">
                  <button type="button" class="btn btn-icon btn-primary" @click="onEditBankAccount(scope.row)"><i class="nc-icon nc-file-edit"></i></button>
                  <button type="button" class="btn btn-icon btn-danger" @click="onDeleteBankAccount(scope.row)"><i class="nc-icon nc-simple-remove"></i></button>
                </template>
              </el-table-column>
              <el-table-column prop="bankName" label="Bank" width="180">
                <template slot-scope="scope">
                  {{scope.row.bankName}}
                </template>
              </el-table-column>
              <el-table-column prop="accountNumber" label="Account Number" width="140"></el-table-column>
              <el-table-column prop="currency" label="Currency" width="90" class="currency"></el-table-column>
              <el-table-column prop="accountName" label="Account Name" width="240"></el-table-column>
              <el-table-column prop="ownerName" label="Owner" width="180">
                <template slot-scope="scope">
                  {{scope.row.firstName}} {{scope.row.lastName}}
                </template>
              </el-table-column>
              <el-table-column prop="security" label="Security" width="90">
                <template slot-scope="scope">
                  <span :class="securityClass(scope.row.security)">{{ scope.row.security | security }}</span>
                </template>
              </el-table-column>
            </el-table>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, ref, watch } from '@vue/composition-api'
import graphql from '@/api/graphql'
import gql from 'graphql-tag'
import router from '@/routes/router'
import BankAccountForm from '@/forms/BankAccountForm.vue'
import VerifyStatus from './VerifyStatus'

export default {
  components: {
    BankAccountForm
  },
  setup(props, context) {
    const root = context.root
    const store = root.$store
    const routeparams = context.root.$route.params
    const tableData = ref([])
    const state = reactive({
      isLoading: false,
    })
    refresh()
    function refresh() {
      state.isLoading = true;
      let graphQuery = gql`{
        bankAccountList {
          id
          bankName
          accountNumber
          accountName
          currency
          countryCode3
          security
          firstName
          lastName
        }
      }`
      graphql.query(graphQuery)
      .then(json => {
        tableData.value = json.data.bankAccountList
        state.isLoading = false;
      })
      .catch(gqlResponse => {
        graphql.handleError(gqlResponse, 'Error getting bank accounts:', store.dispatch)
        state.isLoading = false;
      })
    }

    function cellClass(v) {
      if (v.columnIndex == 3) {
        return 'currency'
      }
      return null
    }

    function onNewBankAccount() {
      // console.log('new bank account')
      router.push(`${process.env.BASE_URL}settings/bank/new`)
    }

    function onEditBankAccount(row) {
      console.log('edit bank account', row)
      router.push(`${process.env.BASE_URL}settings/bank/` + row.id)
    }

    function onDeleteBankAccount(row) {
      console.log('delete bank account', row)
      root.$confirm('This will permanently delete \'' + row.bankName + '\'. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        let graphQuery = gql`mutation BankAccountList($id: ID) {
          bankAccountDelete(id: $id) {
            id
            bankName
            accountNumber
            accountName
            currency
            countryCode3
            security
            firstName
            lastName
          }
        }`
        graphql.query(graphQuery, {
          id: row.id
        })
        .then(json => {
          tableData.value = json.data.bankAccountDelete
          store.dispatch('notify', { type: 'success', message: 'Bank Account deleted'})
        })
        .catch(gqlResponse => {
          graphql.handleError(gqlResponse, 'Error deleting Bank Account:', store.dispatch)
        })
      }).catch(() => {
      })
    }

    // setup return
    return {
      state,
      tableData,
      cellClass,
      'securityClass': VerifyStatus.bankAccountClass,
      onNewBankAccount,
      onEditBankAccount,
      onDeleteBankAccount
    }
  },
  filters: {
    security: function (value) {
      const map = {
        review: 'review',
        pending: 'testing',
        approved: 'active',
        hold: 'hold'
      }
      if (value in map) {
        return map[value]
      }
      return value
    }
  }
}
</script>
<style lang="scss">
  .el-table.bankaccounts {
    td.currency {
      text-transform: uppercase;
      color: #aaa;
    }
    td {
      text-align: center;
      span.badge {
        min-width: 54px;
      }
    }
  }

</style>